module.exports = __webpack_public_path__ + "static/media/suv_green.263ecf26.svg";